import React, { useEffect } from "react";
import TabPanel from "./userTabs";
import { Button, Dialog } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ProviderTable from "./ProviderTable";
import { ProviderService } from "../../../services/provider.service";
import ProviderForm from "../../shared/user/ProviderForm";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";

const Provider = ({ value, index, addAlert, detailAlert }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [resetCheckBox, setResetCheckbox] = React.useState(false);
  const [providerArray, setProviderArray] = React.useState([]);

  useEffect(() => {
    getProviders();
  }, []);

  const getProviders = async () => {
    try {
      const { data } = await ProviderService.getAllProvidersActive();
      setProviderArray(data);
    } catch (error) {
      console.log("error ", error);
      addAlert({ showAlert: true });
      detailAlert({ severity: "error", message: error.msgs });
    }
  };

  const handleActionProvider = async (action, provider) => {
    console.log("hanbdleActionProvider");
    console.log("handleActionProvider", action);
    console.log("validate", action === "create");
    if (action === "create") {
      console.log("enter here");
      try {
        const { status } = await ProviderService.createProvider(provider);
        if (status === 201) {
          setOpenDialog(false);
          addAlert({ showAlert: true });
          detailAlert({
            severity: "success",
            message: "Proveedor creado exitosamente",
          });
          getProviders();
        }
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    }
  };

  const handleCloseDialog = () => setOpenDialog(false);

  const providerRemove = (isUserRemove) => {
    addAlert({ showAlert: true });
    console.log("isProviderRemove", isUserRemove);
    if (isUserRemove) {
      getProviders();
      detailAlert({
        severity: "success",
        message: "Proveedor(es) eliminado exitosamente",
      });
      setResetCheckbox(true);
    } else {
      detailAlert({
        severity: "error",
        message: "Error, no se pudo eliminar al proveedor(es)",
      });
    }
  };

  const handleReloadProviders = (usersType) => {
    getProviders();
    setResetCheckbox(true);
  };

  return (
    <React.Fragment>
      <TabPanel value={value} index={index}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenDialog(true)}
          style={{ margin: "4vh 1vh" }}
          endIcon={<AddIcon color="secondary"></AddIcon>}
        >
          Nuevo proveedor
        </Button>

        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="form-dialog-title"
        >
          <ProviderForm
            providerAction={handleActionProvider}
            closeDialog={handleCloseDialog}
          />
        </Dialog>
        <ProviderTable
          resetCheckox={resetCheckBox}
          providersArray={providerArray}
          isUserDeleted={providerRemove}
          loadUsers={handleReloadProviders}
        ></ProviderTable>
      </TabPanel>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(Provider);
